<template lang="slm">
  .audio.color-dark
    .img-container
      .img :style='"background-image:url(/api/file/" + imageId + ")"'
        play-pause-circle :playing='playing' :loading='loading' :progress='progress' @click='playPauseClick()' :class='{ "first-time": progress === 0 && !loading }'
    h3.mt-3.mb-1.font-weight-semi-bold {{ title }}
    span.font-weight-light {{ speaker }}
    small.font-weight-light {{ date | date }}
</template>

<style lang="stylus" scoped>
.audio
  text-align left
  display inline-flex
  flex-direction column
  max-width 100%
  .img-container
    position relative
    width 255px
    max-width 100%
    .img
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      background-position center
      background-repeat no-repeat
      background-size cover
      display flex
      align-items center
      justify-content center
      &:hover
        .circle.first-time
          opacity 1
      .circle
        transition opacity 0.1s linear
        &.first-time
          opacity 0
    &:before
      content ''
      padding-top 100%
      width 100%
      display block
  h3
    font-weight 600 !important
    font-style italic !important
    font-size 24px !important
  span
    font-size 24px !important
    font-weight 300 !important
  small
    font-size 18px !important
    font-weight 300 !important
    margin-top -3px
</style>

<script>
import PlayPauseCircle from '@/components/PlayPauseCircle';

export default {
  name: 'AudioPreach',
  components: { PlayPauseCircle },
  props: {
    imageId: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    speaker: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 0,
    },
    fileId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      playing: false,
      loading: false,
      progress: 0,
    };
  },
  methods: {
    playPauseClick() {
      if (this.loading) return;
      if (this.playing) {
        this.$root.pauseAudio();
      } else {
        this.$root.playAudio({
          title: this.title,
          author: this.speaker,
          fileId: this.fileId,
          duration: this.duration,
          startFromPersent: this.progress,
          eventsHandler: {
            setPlaying: (value) => {
              this.playing = value;
            },
            setLoading: (value) => {
              this.loading = value;
            },
            setProgressPersent: (value) => {
              this.progress = value;
            },
          },
        });
      }
    },
  },
};
</script>
